import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import ScreenReaderOnlyText from "../../../helpers/ScreenReaderOnlyText";
import CTA from '../CTA';
import styles from './IconButton.module.scss';
const IconButton = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement(CTA, Object.assign({ Tag: "button", className: cn(styles.iconButton, className) }, props),
        React.createElement(ScreenReaderOnlyText, null, children)));
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map